


import vue from 'vue'
import router from 'vue-router'
vue.use(router)



import home from '@/components/home/home.vue'



export default new router({
	mode : 'history',
	routes : [
		{
			path : '/',
			component : home
		},
		{
			path : '/films',
			component : home
		},
		{
			path : '/films/:filmID/',
			component : home
		},
		{
			name : 'trailer',
			path : '/films/:filmID/trailer',
			component : home,
			beforeEnter : (to, from, next) => {
			
				if (to.params.filmID === 'sound-of-metal') {
					return next(false)
				} else {
					return next()
				}

			}
		},
		{
			path : '*',
			component : home
		}
	]
})



// WEBPACK FOOTER //
// ./src/app-router.js